import { DynamicFlowLocation, DynamicFlowLocationAnswer } from '../model/dynamic-flow.types';

export const DEFAULT_DISTANCE_IN_KM = 10;

export function defaultLocationToAnswer(
  defaultLocation: DynamicFlowLocation['defaultLocation'],
): DynamicFlowLocationAnswer | null {
  if (!defaultLocation) return null;

  return {
    city: defaultLocation.city,
    distanceInKm: DEFAULT_DISTANCE_IN_KM,
    coordinates: {
      latitude: defaultLocation.coordinates.latitude,
      longitude: defaultLocation.coordinates.longitude,
    },
    country: null,
    countryCode: null,
    postalCode: null,
    street: null,
  };
}
